<template>
  <div class="header">
    <img class="head" src="../../assets/images/1304/header.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "Head",
  components: {},
  data () {
    return {
    };
  },
  props: {
    webInfoObj: {
      type: Object,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="less">
.header {
  box-sizing: border-box;
  position: relative;
  font-size: 0;
  .head {
    display: block;
    width: 100%;
    margin: 0 auto;
    height: 100%;
  }
}
</style>